module.exports = __webpack_public_path__ + "static/img/footer_logo.8c02f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer_logo.png
// module id = /U0d
// module chunks = 19